import * as React from "react";
import classnames from "classnames";
import { TextArea as TextArea$1 } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import Field, { DefaultError } from "../../Field/Field/Field.js";
/* empty css              */
const CounterFooter = ({ count, errorMessage, id, showError }) => {
  const { getFormattedLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "textarea-component__message" }, showError && /* @__PURE__ */ React.createElement(
    DefaultError,
    {
      id: `${id}_error`,
      className: "textarea-component__error",
      message: errorMessage
    }
  ), count !== null && /* @__PURE__ */ React.createElement(
    "p",
    {
      id: `${id}_count`,
      "aria-label": getFormattedLabel("fields.textarea.charactersRemaining", {
        labelData: {
          amount: count
        }
      }),
      className: classnames("textarea-component__count", {
        "textarea-component__count--error": count < 1
      })
    },
    count
  ));
};
CounterFooter.displayName = "CounterFooter";
const TextArea = ({
  errorMessage,
  name,
  id,
  label,
  placeholder,
  maxLength,
  validations,
  required,
  disabled,
  className,
  "data-t": testId,
  ...rest
}) => {
  const resolvedId = id || name;
  const initialCount = maxLength ? maxLength : null;
  const [count, setCount] = React.useState(initialCount);
  const handleEvent = React.useCallback(
    (state) => {
      maxLength && setCount(maxLength - state.value.length);
    },
    [maxLength]
  );
  const renderError = (showError) => /* @__PURE__ */ React.createElement(
    CounterFooter,
    {
      id: resolvedId,
      count,
      errorMessage,
      showError
    }
  );
  return /* @__PURE__ */ React.createElement(
    Field,
    {
      ...rest,
      name,
      id: resolvedId,
      label,
      className: classnames("textarea-component", className),
      required,
      disabled,
      placeholder,
      validations,
      error: renderError,
      onChange: handleEvent,
      onBlur: handleEvent
    },
    /* @__PURE__ */ React.createElement(
      TextArea$1,
      {
        name,
        maxLength,
        "aria-describedby": `${resolvedId}_error ${resolvedId}_count`,
        "data-t": testId
      }
    )
  );
};
export {
  CounterFooter,
  TextArea as default
};
//# sourceMappingURL=TextArea.js.map
